export default __webpack_public_path__ + "static/media/Tablet.abd2c922.png";